<div class="col-xs-12 locations_tablesection">
  <div [style.display]="isRowClicked?'':'none'"  class="locations_disablebg"></div>
  <div class="col-xs-12 locations_header">{{'orgLocation.loctextuk' | cxTranslate}}</div>
  <div class="clearfix"></div>
  @if (isLoading) {
    <div class="loading">
      <div class="loading_txt">
        <div class="load_txt">{{'orgLocation.loading' | cxTranslate}}</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }
  <!-- mobile Filter -->
  <div class="locations_filtering">
    <div class="col-xs-12 locations_filterbox" (click)="filterClick()">
      <div class=" locations_filterLabel">{{'orgLocation.filterlabel' | cxTranslate}}</div>
      <span class=" locations_filterarrow glyphicon glyphicon-menu-down"></span>
    </div>
    <div class="clearfix"></div>
    <div [style.display]="isFilterOpen?'':'none'" class="locations_filteropen">
      <div class="location_checkboxparent">
        <label class="checkbox-button">
          <input type="checkbox" name="checkbtn" value="Type" class="location_checkbox" (change)="sortTest('type')">
          <span class="checkbox-button__control"></span>
        </label>
        <label>{{'orgLocation.typelabel' | cxTranslate}}</label>
      </div>
      <div class="location_checkboxparent">
        <label class="checkbox-button">
          <input type="checkbox" name="checkbtn" value="Name" class="location_checkbox" (change)="sortTest('name')">
          <span class="checkbox-button__control"></span>
        </label>
        <label>{{'orgLocation.namelabel' | cxTranslate}}</label>
      </div>
      <div class="location_checkboxparent">
        <label class="checkbox-button">
          <input type="checkbox" name="checkbtn" value="Address" class="location_checkbox" (change)="sortTest('address')">
          <span class="checkbox-button__control"></span>
        </label>
        <label>{{'orgLocation.addresslabel' | cxTranslate}}</label>
      </div>
      <div class="location_checkboxparent">
        <label class="checkbox-button">
          <input type="checkbox" name="checkbtn" value="MainContact" class="location_checkbox" (change)="sortTest('mainContact')">
          <span class="checkbox-button__control"></span>
        </label>
        <label>{{'orgLocation.contactlabel' | cxTranslate}}</label>
      </div>
      <div class="location_checkboxparent">
        <label class="checkbox-button">
          <input type="checkbox" name="checkbtn" value="PhoneNumber" class="location_checkbox" (change)="sortTest('phoneNumber')">
          <span class="checkbox-button__control"></span>
        </label>
        <label>{{'orgLocation.phnlabel' | cxTranslate}}</label>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div id="locationstable_wrapper" class="dataTables_wrapper no-footer">
    <table id="locationstable" class="display nowrap locationstable" width="100%" mat-table multiTemplateDataRows matSort (matSortChange)="onSortChange($event)" [dataSource]="dataSource">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="org_NameUK">{{'orgLocation.namelabeluk' | cxTranslate}}
          <span>
            <img [ngClass]="{'rotated': currentSort === 'desc' && activeCol == 'name','unsorted':activeCol != 'name'}" src="assets/images/sort_grey.png"/>
          </span>
        </th>
        <td mat-cell *matCellDef="let row" data-label="name" >{{row.name}}</td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header  disableClear="true" class="address_LabelUk">{{'orgLocation.addresslabel' | cxTranslate}}
          <span >
            <img [ngClass]="{'rotated': currentSort === 'desc' && activeCol == 'address','unsorted':activeCol != 'address'}" src="assets/images/sort_grey.png"/>
          </span></th>
          <td mat-cell *matCellDef="let row" data-label="address" >{{row.address}}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="org_LocUK">{{'orgLocation.typelabel' | cxTranslate}}
            <span>
              <img [ngClass]="{'rotated': currentSort === 'desc' && activeCol == 'type','unsorted':activeCol != 'type'}" src="assets/images/sort_grey.png"/>
            </span>
          </th>
          <td mat-cell *matCellDef="let row" data-label="type" >{{row.type}}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef  mat-sort-header disableClear="true" class="contact_LabelUK">{{'orgLocation.contactlabeluk' | cxTranslate}}
            <span>
              <img [ngClass]="{'rotated': currentSort === 'desc' && activeCol == 'email','unsorted':activeCol != 'email'}" src="assets/images/sort_grey.png"/>
            </span>
          </th>
          <td mat-cell *matCellDef="let row" data-label="email" >{{row.email}}</td>
        </ng-container>
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef  mat-sort-header disableClear="true" class="phn_LabelUK">{{'orgLocation.phnlabel' | cxTranslate}}
            <span>
              <img [ngClass]="{'rotated': currentSort === 'desc' && activeCol == 'phoneNumber','unsorted':activeCol != 'phoneNumber'}" src="assets/images/sort_grey.png"/>
            </span>
          </th>
          <td mat-cell *matCellDef="let row" data-label="phoneNumber">{{row.phn?.length === 10 ? (row.phn | mask: '0000000000'):(row.phn | mask: '00000000000') }}@if (row.ext) {
            &nbsp;Ext.{{row.ext}}
          }</td>
        </ng-container>
        <ng-container matColumnDef="viewDetails">
          <th mat-header-cell *matHeaderCellDef class="view_Details_Th"></th>
          <td mat-cell *matCellDef="let row" class="details-control">
            <div (click)="viewDetails(row)">{{isRowExpanded(row) ? 'View Details':'View Details'}}</div>
          </td>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        @if (isRowExpanded(selectedElement) || !selectedElement) {
          <tr #tablemainrow mat-row *matRowDef="let row; columns:displayedColumns;let i=index" [class.row-hide]="!(isRowExpanded(row) || selectedElement===null)" class="main-row1">
          </tr>
        }
        <!-- expanded row -->
        @if (isRowExpanded(selectedElement)) {
          <div>
            <tr *matRowDef="let row ;columns:[]" [ngClass]="row.type == 'Delivery'?'locations_border':'locations_border billship'" [class.row-hide]="!(isRowExpanded(row) || selectedElement===null)">
              @if (isRowExpanded(row)) {
                <td class="mob-details-td" [attr.colspan]="6">
                  @if (editElement !== row) {
                    <div class="col-xs-12 locations_editsection">
                      <div class="col-xs-12 col-md-2 locations_edit">
                        @if (orgukrba?.RBAPermissions==true) {
                          @if (orgukrba?.currentUserAccountPermission=='MANAGE') {
                            @if (row.status !== 'PENDING' && (!isAsAgent || (isSearchByProfile && isAsAgent))) {
                              <div class="locations_editbtn" (click)="onEdit(row)">Edit <div class="locations_editicon"></div></div>
                            }
                          }
                        } @else {
                          @if (row.status !== 'PENDING' && (!isAsAgent || (isSearchByProfile && isAsAgent))) {
                            <div class="locations_editbtn" (click)="onEdit(row)">Edit <div class="locations_editicon"></div></div>
                          }
                        }
                        <div class="locations_closeicon" [attr.id]="row.addressId" (click)="close()"></div>
                      </div>
                      <div class="col-xs-12 col-md-5"><div class="locations_editheader">{{'orgLocation.contactInfo' | cxTranslate}}</div> <br>
                      <div class="locations_editsubheader">{{'orgLocation.orgNameukLabel' | cxTranslate}}</div>{{row.name}}
                      <br><br>
                      <div class="locations_editsubheader">{{'orgLocation.addresslabel' | cxTranslate}}</div>{{row.addrLine1}}<br> {{row.addrLine2}}&nbsp;{{row.city}}<br>{{row.zipCode}}<br><br>
                      <div class="locations_editsubheader">{{'orgLocation.contactInfoLabel' | cxTranslate}}</div>{{row.mainContact}}<br>{{row.email}}<br>{{row.phoneNumber}}<br><br>
                    </div>
                    <div class="col-xs-12 col-md-5" [ngClass]="row.type == 'Delivery'?'locations_optional':'locations_optional test'"><div class="locations_editheader">{{'orgLocation.fulllicInfouk' | cxTranslate}}</div> <br>
                    <div class="locations_editsubheader">{{'orgLocation.licNameuk' | cxTranslate}}</div>{{row.licenseName}} <br><br><div class="locations_editsubheader">{{'orgLocation.licNumuk' | cxTranslate}}</div>{{row.licenseNumber}}<br><br><div class="locations_editsubheader">NHS Code</div>{{row.nhsNumber}}<br><br></div>
                  </div>
                } @else {
                  <form id="locations_editform" [formGroup]="orgLocationsUpdateForm" (ngSubmit)="updateLocation()">
                    <div>
                      <div class="col-xs-12 locations_editsection locations_editsectionuk">
                        <div class="col-xs-12 col-md-2"><div class="locations_edit"><button type="submit" class="locations_savebtn">Save <div class="locations_saveicon"></div></button><div class="locations_closeicon" (click)="close()"></div></div></div>
                        <div class="col-xs-12 col-md-5">
                          <div class="locations_editheader col-xs-12">{{'orgLocation.contactInfo' | cxTranslate}}</div>
                          <br><br>
                          <div class="locuk_editheader col-xs-12">Contact Info</div>
                          <div class="">
                            <div class="col-xs-6 form-group"><label class="locations_inputheader">{{'orgLocation.firstNameLabel' | cxTranslate}}<sup>*</sup></label>
                            <div class="input-group">
                              <input type="text" id="loc_editfname" name="loc_editfname" class="form-control" formControlName="loc_editfname">
                              @if (orgLocationsUpdateForm.get('loc_editfname')?.touched && orgLocationsUpdateForm.get('loc_editfname')?.invalid) {
                                <span class="input-group-addon">
                                  <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                                </span>
                              }
                            </div>
                            @if (orgLocationsUpdateForm.get('loc_editfname')?.touched && !orgLocationsUpdateForm.get('loc_editfname')?.hasError('required') && orgLocationsUpdateForm.get('loc_editfname')?.hasError('invalidName')) {
                              <div class="error help-block">{{'orgLocform.errorOnlyLetters' | cxTranslate}}</div>
                            }
                            @if (orgLocationsUpdateForm.get('loc_editfname')?.touched &&  orgLocationsUpdateForm.get('loc_editfname')?.hasError('required')) {
                              <div class="error help-block">{{'orgLocform.errorFirstName' | cxTranslate}}</div>
                            }
                          </div>
                        </div>
                        <div class="">
                          <div class="col-xs-6 form-group location_lastname"><label class="locations_inputheader">{{'orgLocation.lastNameLabel' | cxTranslate}}<sup>*</sup></label>
                          <div class="input-group">
                            <input type="text" id="loc_editlname" name="loc_editlname" class="form-control" formControlName="loc_editlname">
                            @if (orgLocationsUpdateForm.get('loc_editlname')?.touched && orgLocationsUpdateForm.get('loc_editlname')?.invalid) {
                              <span class="input-group-addon">
                                <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                              </span>
                            }
                          </div>
                          @if (orgLocationsUpdateForm.get('loc_editlname')?.touched && !orgLocationsUpdateForm.get('loc_editlname')?.hasError('required') && orgLocationsUpdateForm.get('loc_editlname')?.hasError('invalidName')) {
                            <div class="error help-block">{{'orgLocform.errorOnlyLetters' | cxTranslate}}</div>
                          }
                          @if (orgLocationsUpdateForm.get('loc_editlname')?.touched && orgLocationsUpdateForm.get('loc_editlname')?.hasError('required')) {
                            <div class="error help-block">{{'orgLocform.errorLastName' | cxTranslate}}</div>
                          }
                        </div>
                      </div>
                      <div class="col-xs-12 form-group"><label class="locations_inputheader">Job Title<sup>*</sup></label>
                      <div class="input-group">
                        <select id="loc_job" name="loc_job" class="loc_editjobuk" formControlName="loc_job">
                          @for (job of jobTitles; track job) {
                            <option value="{{job}}">{{job}}</option>
                          }
                        </select>
                        @if (orgLocationsUpdateForm.get('loc_job')?.touched && orgLocationsUpdateForm.get('loc_job')?.invalid) {
                          <span class="input-group-addon">
                            <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                          </span>
                        }
                      </div>
                      @if (orgLocationsUpdateForm.get('loc_job')?.touched && orgLocationsUpdateForm.get('loc_job')?.hasError('required')) {
                        <div class="error help-block">{{'orgLocform.errorJobTitle' | cxTranslate}}</div>
                      }
                    </div>
                    <div class="">
                      <div class="col-xs-12 form-group"><label class="locations_inputheader">{{'orgLocation.emailLabel' | cxTranslate}}<sup>*</sup></label>
                      <div class="input-group">
                        <input type="text" id="loc_editemail" name="loc_editemail" class="form-control" formControlName="loc_editemail">
                        @if (orgLocationsUpdateForm.get('loc_editemail')?.invalid) {
                          <span class="input-group-addon">
                            <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                          </span>
                        }
                      </div>
                      @if (orgLocationsUpdateForm.get('loc_editemail')?.hasError('pattern')) {
                        <div class="error help-block">{{'orgLocform.errorValidEmail' | cxTranslate}}</div>
                      }
                      @if (orgLocationsUpdateForm.get('loc_editemail')?.hasError('required')) {
                        <div class="error help-block">{{'orgLocform.errorEmail' | cxTranslate}}</div>
                      }
                    </div>
                  </div>
                  <div class="editsubheader_enable"><div class="col-xs-6 form-group"><label class="locations_inputheader">{{'orgLocation.phnlabeluk' | cxTranslate}}<sup>*</sup></label>
                  <div class="input-group">
                    <input type="text" id="loc_editphone" name="loc_editphone" class="form-control" maxlength="11" formControlName="loc_editphone">
                    @if (orgLocationsUpdateForm.get('loc_editphone')?.touched && orgLocationsUpdateForm.get('loc_editphone')?.invalid) {
                      <span class="input-group-addon">
                        <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                      </span>
                    }
                  </div>
                  @if (orgLocationsUpdateForm.get('loc_editphone')?.touched && orgLocationsUpdateForm.get('loc_editphone')?.hasError('pattern')) {
                    <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
                  }
                  @if (orgLocationsUpdateForm.get('loc_editphone')?.touched && orgLocationsUpdateForm.get('loc_editphone')?.hasError('required')) {
                    <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
                  }
                  @if (orgLocationsUpdateForm.get('loc_editphone')?.touched && !orgLocationsUpdateForm.get('loc_editphone')?.hasError('pattern') && orgLocationsUpdateForm.get('loc_editphone')?.hasError('minlength')) {
                    <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
                  }
                  @if (orgLocationsUpdateForm.get('loc_editphone')?.touched && !orgLocationsUpdateForm.get('loc_editphone')?.hasError('pattern') && orgLocationsUpdateForm.get('loc_editphone')?.hasError('maxlength')) {
                    <div class="error help-block">{{'orgLocform.errorValidPhnuk' | cxTranslate}}</div>
                  }
                </div>
              </div>
              <div class="editsubheader_enable"><div class="col-xs-4 form-group location_ext"><label class="locations_inputheader">{{'orgLocation.extlabel' | cxTranslate}}</label>
              <div class="input-group">
                <input type="text" id="loc_editext" name="loc_editext" class="form-control" maxlength="4" formControlName="loc_editext">
                @if (orgLocationsUpdateForm.get('loc_editext')?.touched && orgLocationsUpdateForm.get('loc_editext')?.value && orgLocationsUpdateForm.get('loc_editext')?.invalid) {
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                  </span>
                }
              </div>
              @if (orgLocationsUpdateForm.get('loc_editext')?.touched &&  orgLocationsUpdateForm.get('loc_editext')?.value && orgLocationsUpdateForm.get('loc_editext')?.hasError('maxlength')) {
                <div class="error help-block">{{'orgLocform.errorExt' | cxTranslate}}</div>
              }
              @if (orgLocationsUpdateForm.get('loc_editext')?.touched &&  orgLocationsUpdateForm.get('loc_editext')?.value && orgLocationsUpdateForm.get('loc_editext')?.hasError('pattern')) {
                <div class="error help-block">{{'orgLocform.errorValidExt' | cxTranslate}}</div>
              }
            </div>
          </div>
          <div class="locations_editlocsubheader col-xs-12">{{'orgLocform.mainAddr' | cxTranslate}}</div><div class="col-xs-12 form-group"><label class="locations_inputheader">{{'orgLocation.orgNameukLabel' | cxTranslate}}</label>
          <div class="input-group">
            <input type="text" id="loc_editorgname" name="loc_editorgname" class="form-control" formControlName="loc_editorgname">
            @if (orgLocationsUpdateForm.get('loc_editorgname')?.touched && orgLocationsUpdateForm.get('loc_editorgname')?.invalid) {
              <span class="input-group-addon">
                <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
              </span>
            }
          </div>
          @if (orgLocationsUpdateForm.get('loc_editorgname')?.touched && orgLocationsUpdateForm.get('loc_editorgname')?.hasError('pattern')) {
            <div class="error help-block">{{'orgLocform.errorValidOrgName' | cxTranslate}}</div>
          }
          @if (orgLocationsUpdateForm.get('loc_editorgname')?.touched && orgLocationsUpdateForm.get('loc_editorgname')?.hasError('required')) {
            <div class="error help-block">{{'orgLocform.errorOrgname' | cxTranslate}}</div>
          }
        </div>
        <div class="col-xs-12 form-group"><label class="locations_inputheader">{{'orgLocform.shipAddrLookup' | cxTranslate}}</label><i class="fa fa-search loc_editsearchicon loc_editsearchiconuk"></i><input type="text" id="loc_editaddlookup" name="loc_editaddlookup" value="" formControlName="loc_editaddlookup" class="loc_editaddlookupuk form-control"></div>
        <div class="col-xs-12 form-group"><label class="locations_inputheader">{{'orgLocform.shipAddrLine1' | cxTranslate}}</label>
        <div class="input-group">
          <input type="text" id="loc_editadd1" name="loc_editadd1" class="form-control" formControlName="loc_editadd1">
          @if (orgLocationsUpdateForm.get('loc_editadd1')?.invalid) {
            <span class="input-group-addon">
              <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
            </span>
          }
        </div>
        @if (orgLocationsUpdateForm.get('loc_editadd1')?.hasError('required')) {
          <div class="error help-block">{{'orgLocform.errorAddr' | cxTranslate}}</div>
        }
      </div>
      <div class="col-xs-12 form-group"><label class="locations_inputheader">{{'orgLocform.shipAddrLine2' | cxTranslate}}</label><input type="text" id="loc_editadd2" name="loc_editadd2" class="form-control" formControlName="loc_editadd2"></div>
      <div class="col-xs-6 form-group"><label class="locations_inputheader">{{'orgLocform.shipCity' | cxTranslate}}</label>
      <div class="input-group">
        <input type="text" id="loc_editcity" name="loc_editcity" class="form-control" formControlName="loc_editcity">
        @if (orgLocationsUpdateForm.get('loc_editcity')?.invalid) {
          <span class="input-group-addon">
            <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
          </span>
        }
      </div>
      @if (orgLocationsUpdateForm.get('loc_editcity')?.hasError('pattern')) {
        <div class="error help-block">{{'orgLocform.errorvalidCity' | cxTranslate}}</div>
      }
      @if (orgLocationsUpdateForm.get('loc_editcity')?.hasError('required')) {
        <div class="error help-block">{{'orgLocform.errorCity' | cxTranslate}}</div>
      }
    </div>
    <div class="col-xs-5 form-group location_zip"><label class="locations_inputheader">{{'orgLocform.shipZipuk' | cxTranslate}}</label><div class="input-group edit-zip"><input type="text" id="loc_editzip" name="loc_editzip" class="form-control" formControlName="loc_editzip">
    @if (orgLocationsUpdateForm.get('loc_editzip')?.invalid) {
      <span class="input-group-addon">
        <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
      </span>
    }
  </div>
  @if (orgLocationsUpdateForm.get('loc_editzip')?.hasError('pattern')) {
    <div class="error help-block">{{'orgLocform.errorzipcodeuk' | cxTranslate}}</div>
  }
  @if (orgLocationsUpdateForm.get('loc_editzip')?.hasError('required')) {
    <div class="error help-block">{{'orgLocform.errorzipcodeuk' | cxTranslate}}</div>
  }
</div>
<div class="col-xs-5 form-group location_country"><label class="locations_inputheader">Country<sup>*</sup></label><input type="text" id="loc_editcountry" name="loc_editcountry" readonly="" value="United Kingdom" class="form-control"></div>
</div>
<div class="col-xs-12 col-md-5" [ngClass]="row.type == 'Delivery'?'locations_optional':'locations_optional test'"><div class="locations_editheader col-xs-12">{{'orgLocation.fulllicInfouk' | cxTranslate}}</div> <br>
<div class="col-xs-12 form-group"><label class="locations_inputheader">{{'orgLocation.licNameuk' | cxTranslate}}<sup>*</sup></label>
<div class="input-group"><input type="text" id="loc_editlicname" name="loc_editlicname" class="form-control" formControlName="loc_editlicname">
  @if (orgLocationsUpdateForm.get('loc_editlicname')?.touched && orgLocationsUpdateForm.get('loc_editlicname')?.invalid) {
    <span class="input-group-addon">
      <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
    </span>
  }
</div>
@if (orgLocationsUpdateForm.get('loc_editlicname')?.touched && orgLocationsUpdateForm.get('loc_editlicname')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorValidLicName' | cxTranslate}}</div>
}
@if (orgLocationsUpdateForm.get('loc_editlicname')?.touched && !orgLocationsUpdateForm.get('loc_editlicname')?.hasError('required') && orgLocationsUpdateForm.get('loc_editlicname')?.hasError('invalidName')) {
  <div class="error help-block">{{'orgLocform.errorOnlyLetters' | cxTranslate}}</div>
}
</div>
<div class="col-xs-12 form-group"><label class="locations_inputheader">{{'orgLocation.licNumuk' | cxTranslate}}<sup>*</sup></label><div class="input-group"><input type="text" id="loc_editlicnum" maxlength="7" name="loc_editlicnum" class="form-control" formControlName="loc_editlicnum">
@if (orgLocationsUpdateForm.get('loc_editlicnum')?.touched && orgLocationsUpdateForm.get('loc_editlicnum')?.invalid) {
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
  </span>
}
</div>
@if (orgLocationsUpdateForm.get('loc_editlicnum')?.touched && orgLocationsUpdateForm.get('loc_editlicnum')?.hasError('required')) {
  <div class="error help-block">{{'orgLocform.errorValidLicNumuk' | cxTranslate}}</div>
}
@if (orgLocationsUpdateForm.get('loc_editlicnum')?.touched && !orgLocationsUpdateForm.get('loc_editlicnum')?.hasError('required') && orgLocationsUpdateForm.get('loc_editlicnum')?.hasError('invalidLicNum')) {
  <div class="error help-block">{{'orgLocform.errorValidLicNumuk' | cxTranslate}}</div>
}
</div>
<div class="col-xs-12 form-group" [ngClass]="{'has-error':orgLocationsUpdateForm.get('loc_editnhsnumb')?.touched && orgLocationsUpdateForm.get('loc_editnhsnumb')?.value && orgLocationsUpdateForm.get('loc_editnhsnumb')?.invalid}"><label class="locations_inputheader">NHS Code</label><div class="input-group"><input type="text" id="loc_editnhsnumb" name="loc_editnhsnumb" value="NA" class="form-control" formControlName="loc_editnhsnumb">
@if (orgLocationsUpdateForm.get('loc_editnhsnumb')?.touched && orgLocationsUpdateForm.get('loc_editnhsnumb')?.value && orgLocationsUpdateForm.get('loc_editnhsnumb')?.invalid) {
  <span class="input-group-addon">
    <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
  </span>
}
</div>
@if (orgLocationsUpdateForm.get('loc_editnhsnumb')?.touched && orgLocationsUpdateForm.get('loc_editnhsnumb')?.value && orgLocationsUpdateForm.get('loc_editnhsnumb')?.hasError('nhserror1')) {
  <div class="error help-block">{{'orgLocform.errorNhsGpadd' | cxTranslate}}</div>
}
@if (orgLocationsUpdateForm.get('loc_editnhsnumb')?.touched && orgLocationsUpdateForm.get('loc_editnhsnumb')?.value && orgLocationsUpdateForm.get('loc_editnhsnumb')?.hasError('nhserror2')) {
  <div class="error help-block">{{'orgLocform.errorNhsPharmaadd' | cxTranslate}}</div>
}
@if (orgLocationsUpdateForm.get('loc_editnhsnumb')?.touched && orgLocationsUpdateForm.get('loc_editnhsnumb')?.value && orgLocationsUpdateForm.get('loc_editnhsnumb')?.hasError('nhserror3')) {
  <div class="error help-block">{{'orgLocform.errorNhsAlladd' | cxTranslate}}</div>
}
</div>
</div>
</div>
</div>
</form>
}
</td>
}
</tr>
</div>
}


</table>

<div [hidden]="isTableHasData" class="center-message dataTables_empty">
  No matching records found
</div>
<div [hidden]="tableDataLoaded" class="center-message dataTables_empty">
  Loading...
</div>

<div class="dataTables_length" id="locationstable_length"><label>Showing <select name="locationstable_length" (change)="onPageSizeChange($event)" [value]="pageSizeControl.value">
  @for (size of pageSizeOptions; track size) {
    <option [value]="size">{{size}}</option>
  }
</select></label></div>
<div class="custom-paginator dataTables_paginate paging_full_numbers" id="locationstable_paginate">
  <button class="pagination-buttonOrg paginate_button" (click)="goToFirstPage()" [disabled]="isFirstPage()">
    <img alt="Navigate to previous page" src="assets/images/pagination-double-prev-arrow-icon.svg" class="locations_arrows">
  </button>
  <button class="pagination-buttonOrg paginate_button" (click)="previousPage()" [disabled]="isFirstPage()">
    <img alt="Navigate to previous page" src="assets/images/pagination-prev-btn.svg" class="locations_arrows">
  </button>
  @for (pge of getPages(); track pge) {
    <button [hidden]="!isTableHasData" class="pagination-buttonOrg paginate_button" [class.active-page]="isCurrentPage(pge)" (click)="goToPage(pge)">
      {{pge}}
    </button>
  }
  <button class="pagination-buttonOrg paginate_button" (click)="nextPage()" [disabled]="isLastPage()">
    <img alt="Navigate to next page" src="assets/images/pagination-next-btn.svg" class="locations_arrows">
  </button>
  <button class="pagination-buttonOrg paginate_button" (click)="goToLastPage()" [disabled]="isLastPage()">
    <img alt="Navigate to last page" src="assets/images/pagination-double-next-arrow-icon.svg" class="locations_arrows">
  </button>

</div>
</div>
</div>